export const MOBIUS = {
	PROPERTY: {
		NODE: "MOBIUS_NODES",
		FLOWCHART: "MOBIUS_FC"
	}
}


// WEBPACK FOOTER //
// C:/Users/Akshata/Documents/GitHub/mobius-dev/src/app/global-services/mobius.constants.ts